import React from "react";

import {times} from "lodash";

import HideText from "@components/HideText";
import Tooltip from "@components/Tooltip";

import styles from "./NutritionChart.scss";
import {NutritionEstimate} from "./interfaces";
import {fragmentsCount, getNutritionTextDescription} from "./utils";

export default function NutritionChart({
  estimates,
}: {
  estimates: NutritionEstimate[];
}): JSX.Element | null {
  if (!estimates?.length) {
    return null;
  }

  return (
    <>
      <div className={styles.nutritionChart}>
        {estimates.map((estimate) => {
          if (!estimate.value) {
            return null;
          }
          return (
            <div key={estimate.name} className={styles.estimateLine}>
              <span className={styles.name}>{estimate.name}</span>
              {/* full description for screen readers */}
              <HideText>{getNutritionTextDescription(estimate)}</HideText>
              <Tooltip content={estimate.bracket}>
                <div
                  className={styles.infoContainer}
                  data-testid={estimate.name}
                >
                  <div className={styles.labels}>
                    <span>Low</span>
                    <span>High</span>
                  </div>
                  <div className={styles.chart}>
                    {times(fragmentsCount(estimate.value), (i) => (
                      <div key={i}></div>
                    ))}
                  </div>
                </div>
              </Tooltip>
            </div>
          );
        })}
      </div>
      <div className={styles.nutritionDisclaimer}>
        This nutritional information is based on a 2,000 calorie balanced daily
        value. Please note that individual dietary needs may vary between age,
        body type, health, etc.
      </div>
    </>
  );
}
